<script setup lang="ts">
import * as yup from 'yup'
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import { computed, reactive } from 'vue'
import { useGameStore } from '@/stores/gameStore.ts'
import Backend from '@/models/backend.ts'
import FormProcess from '@/models/formProcess.ts'
import FormInput from '@/components/Interface/Modal/Forms/FormInput.vue'
import FormGenericError from '@/components/Interface/Modal/Forms/FormGenericError.vue'
import { useShipDesignStore } from '@/stores/shipDesignStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'

// Get the ship design data
const gameStore = useGameStore()
const shipDesignStore = useShipDesignStore()
const shipDesignData = computed(() => shipDesignStore.getShipDesignById(gameStore.modalData.shipDesignId))

const backend = new Backend()
const formProcess = new FormProcess()

// Define the validation schema
const schema = yup.object().shape({
  shipDesignName: yup
    .string()
    .min(3, () => `Use at least 3 characters`)
    .max(32, () => `Do not use more than 32 characters`)
    .required(() => `This is required`)
})

// Default form values
const formValues = reactive<{ [key: string]: string }>({
  shipDesignName: shipDesignData.value?.name || ''
})

// Form errors
const formErrors = reactive<{ [key: string]: string }>({
  generic: '',
  shipDesignName: ''
})

// Handle form submission
const submit = () => {
  schema
    .validate(formValues)
    .then(() => {
      formProcess.resetFormErrors(formErrors)
      backend
        .updateShipDesignName(gameStore.modalData.shipDesignId, formValues.shipDesignName)
        .then(() => formProcess.processBackendSuccessResponse())
        .catch((error) => formProcess.processBackendErrorResponse(error, formErrors))
    })
    .catch((error) => formProcess.processFrontendErrorResponse(error, formErrors))
}
</script>

<template>
  <SmallModel title="Edit Ship Design Name">
    <form method="post" @submit.prevent="submit" class="pl-4 pr-4 pt-4">
      <FormInput
        label="Ship design name"
        v-model="formValues.shipDesignName"
        :error="formErrors.shipDesignName"
        :autoFocus="true"
      />
      <div class="flex justify-between py-2">
        <FormGenericError :error="formErrors.generic" />
        <ActionButton type="submit" class="hidden md:block">Edit</ActionButton>
      </div>
    </form>
  </SmallModel>
</template>

<style scoped lang="scss"></style>